import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Row, Col, Button } from 'react-bootstrap';
import SitagLogo from '../../../../styles/images/sitag-logo.png';
import BackIcon from '../../../../styles/images/back-without-bg.png';
import { handleChangeInputSupportPage, 
    handleChangeDisabledBtnPageSupport, 
    handleChangeLoaderPageSupport, 
    handleChangeBtnClassPageSupport } from "../../../../redux/actions/pages/support";
import { handleSetBackdropLoading } from '../../../../redux/actions/loaders';
import { handleSetOpenCustomSnackbar } from '../../../../redux/actions/snackbar';
import Swal from 'sweetalert2';
import { BASE_SITE, CONTACT_US } from '../../../../apis'; 
import axios from "axios";
import * as qs from "querystring";

const Support = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { token } = useSelector(state => state.user);
    const { phoneNumber, message, disabledBtn, btnClass } = useSelector(state => state.support);

    const handleBackBtn = () => {
        navigate(-1);
    };

    const btnOkSingle = Swal.mixin({
        customClass: {
            confirmButton: 'primary-border primary-txt-color font-weight-300 radius-12 w-100 py-2 px-5',
        },
        buttonsStyling: false
    });

    const validationPhoneNumber = (event) => {
        const {value: phone} = event.target;
        
        if(phone.length <= 11) {
            handleChangeInputPhonePageSupport(phone);
        }
        else
            btnOkSingle.fire({
                title: "خطا در ورود",
                text: "شماره موبایل نباید بیشتر از 11 رقم باشد.",
                imageUrl: SitagLogo,
                imageHeight: 80,
                imageAlt: 'سیتگ',
                confirmButtonText: "باشه",
            });
    };

    const handleChangeInputPhonePageSupport = (event) => {
        const {name, value} = typeof event === 'string' ? {name: "phoneNumber", value: event} : event.target;
        dispatch(handleChangeInputSupportPage(name, changeNumberPersianAndArabic(value)));
    };

    const handleChangeInputs = (event) => {
        const {name, value} = event.target;
        dispatch(handleChangeInputSupportPage(name, value));
    };

    const changeNumberPersianAndArabic = (str) => {
        let
            persianNumbers = [/۰/g, /۱/g, /۲/g, /۳/g, /۴/g, /۵/g, /۶/g, /۷/g, /۸/g, /۹/g],
            arabicNumbers = [/٠/g, /١/g, /٢/g, /٣/g, /٤/g, /٥/g, /٦/g, /٧/g, /٨/g, /٩/g];
        if (typeof str === 'string') {
            for (let i = 0; i < 10; i++) {
                str = str.replace(persianNumbers[i], i).replace(arabicNumbers[i], i);
            }
        }
        return str;
    }


    const handleBtnFormSupport = (event) => {
        event.preventDefault();

        apiSupport();
    };


    const apiSupport = () => {
        dispatch(handleSetBackdropLoading(true));
        dispatch(handleChangeLoaderPageSupport(true));
        dispatch(handleChangeDisabledBtnPageSupport(true));

        axios({
            method: 'post',
            url: BASE_SITE + CONTACT_US,
            data: qs.stringify({
                mobile: phoneNumber,
                comment: message,
                introduced_code:'',
            }), headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/x-www-form-urlencoded', 
                'Authorization' : (!!token ? token : '')
            },
        }).then((response) => {
            switch (response.data.status) {
                case 'error':
                    btnOkSingle.fire({
                        title: "خطا ",
                        text: response.data.message,
                        imageUrl: SitagLogo,
                        imageHeight: 80,
                        imageAlt: 'سیتگ',
                        confirmButtonText: "تایید",
                    });
                    break;
                case 'ok':
                    dispatch(handleChangeInputSupportPage('message', ''));
                    dispatch(handleSetOpenCustomSnackbar(true, {message: 'پیام شما با موفقیت ثبت شد', severity: 'success', vertical: 'top', horizontal: 'center'}));  
                    break;
                default:
                    btnOkSingle.fire({
                        title: "خطا در ورود",
                        text: "لطفا مجددا تلاش کنید.",
                        imageUrl: SitagLogo,
                        imageHeight: 80,
                        imageAlt: 'سیتگ',
                        confirmButtonText: "تایید",
                    });
            }
            dispatch(handleSetBackdropLoading(false));
            dispatch(handleChangeLoaderPageSupport(false));
            dispatch(handleChangeDisabledBtnPageSupport(false));
        }, () => {
            btnOkSingle.fire({
                title: "خطا در ورود",
                text: "لطفا مجددا تلاش کنید.",
                imageUrl: SitagLogo,
                imageHeight: 80,
                imageAlt: 'سیتگ',
                confirmButtonText: "تایید",
            });
            dispatch(handleSetBackdropLoading(false));
            dispatch(handleChangeLoaderPageSupport(false));
            dispatch(handleChangeDisabledBtnPageSupport(false));
        });
    };

    return (

        <div id="support-page">
            <Row className="py-3 white-bg sticky top-0 z-index-2">
                <Col xs={1} className="d-flex align-items-center"><img src={BackIcon} alt="back" onClick={handleBackBtn} role="button" /></Col>
                <Col xs={10} className="text-center">
                    <div className="header_h3">
                        پشتیبانی
                    </div>
                </Col>
                <Col xs={1}></Col>
                <Col xs={12} className="header_h4 text-center mt-2">
                    تیم سیتگ از ابتدا تا انتها با افتخار همراه شما خواهد بود
                </Col>
            </Row>

            <Row className="mt-5">
                <Col xs={12}>
                    پشتیبانی کاربران: <a href="tel:+989175557561">09175557561</a>
                </Col>
                <Col xs={12}>
                    پشتیبانی کسب و کارها: <a href="tel:+989175557562">09175557562</a>
                </Col>
            </Row>

            <Row className="mt-4">
                <Col xs={12} className="mt-4 font-weight-300" style={{fontSize: "22px"}}>ارسال پیام</Col>
                { !token ?
                <Col xs={12} className="text-center mt-1">
                    <div className="input-wrapper" >
                        <label className="label-wrapper ml-3" htmlFor="first" >شماره موبایل</label>
                        <input name="phoneNumber" type="text" 
                                value={phoneNumber} 
                                onChange={validationPhoneNumber} 
                                className="w-100 px-2 form-input custom-input custom-vertical-padding" />
                    </div>
                </Col>
                : '' }
                <Col xs={12} className="text-center mt-1">
                    <div className="input-wrapper" >
                        <label className="label-wrapper ml-3" htmlFor="first" >متن پیام</label>
                        <textarea name="message" 
                                value={message} 
                                onChange={handleChangeInputs} 
                                className="w-100 px-2 form-input custom-input custom-vertical-padding"
                                style={{height: "120px"}}></textarea>
                    </div>
                </Col>
            </Row>

            <Row className="mt-1">
                <Col className="text-center mt-4">
                    <Button className={`w-100 custom-vertical-padding login-form-button ${btnClass}`} disabled={disabledBtn} onClick={handleBtnFormSupport}>
                        ارسال پیام
                    </Button>
                </Col>
            </Row>

        </div>

    );
}

export default Support;